













































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import logistics from './components/logistics.vue';
import aRefund from './components/aRefund.vue';
import { afterList, aRefundDetail, successOrder } from '@/utils/api';
import fuzzySearch from '../common/fuzzySearch.vue';
import tableEmpty from '@/components/empty/tableEmpty.vue';

interface optionList {
  aftersaleType: number;
  name: string;
}
interface searchForm {
  code: string | null;
  userOrderId: string | null;
  aftersaleType: number | null;
  partnerId: string | null;
}
interface afterForm {
  aftersaleType: number | null;
  // 售后服务类型,1维修，2换货，3退货
  code: string | null;
  // 售后单编号
  page: number;
  // 条数
  size: number;
  // 页码
  userOrderId: string | null;
  // 用户订单ID
  partnerId: string | null;
}
interface searchItem {
  value: string;
  code: string;
}
@Component({
  components: {
    logistics,
    aRefund,
    fuzzySearch,
    tableEmpty,
  },
})
export default class afterSale_list extends Vue {
  @Watch('dialogFormVisible1', { immediate: true, deep: true })
  onWatchHandler(val) {
    console.log(val);
    if (!val) {
      this.$nextTick(() => {
        this.afterList(this.afterForm);
      });
    }
  }
  currentPage: number = 1;
  pagesize: number = 10;
  totalElements: number = 0;
  optionList: Array<optionList> = [
    {
      aftersaleType: 1,
      name: '维修',
    },
    {
      aftersaleType: 2,
      name: '换货',
    },
    {
      aftersaleType: 3,
      name: '退货',
    },
  ];
  searchForm: searchForm = {
    code: null,
    userOrderId: null,
    aftersaleType: null,
    partnerId: null,
  };
  tableData2: Array<Object> = [];
  dialogFormVisible1: boolean = false;
  drawer: boolean = false;
  // 收集请求列表数据
  afterForm: afterForm = {
    aftersaleType: null,
    // 售后服务类型,1维修，2换货，3退货
    code: null,
    // 售后单编号
    page: 0,
    // 条数
    size: this.pagesize,
    // 页码
    userOrderId: null,
    // 用户订单ID
    partnerId: null,
  };
  nowCode: string = null;
  finalAftersaleType: number = null;
  loading: boolean = false;
  searchItem: searchItem = {
    value: '',
    code: '',
  };
  mounted() {
    this.afterList(this.afterForm);
  }
  // 收集模糊搜索商家名称
  fuzzySearchValue(item) {
    this.searchItem = item;
    this.searchForm.partnerId = item.code;
  }
  //完成发货重新请求列表
  toCompleteDelivery(val) {
    // console.log(val);
    if (val) {
      this.afterList(this.afterForm);
    }
  }
  selectChange(value) {}
  // 完成售后单
  successButton(row) {
    successOrder({ code: row.code })
      .then((res) => {
        if (res) {
          this.afterList(this.afterForm);
          this.$message.success(res);
        }
      })
      .catch((err) => {
        this.afterList(this.afterForm);
        console.log(err);
        this.$message.error(err);
      });
  }
  // 查询
  search() {
    let { code, userOrderId, aftersaleType, partnerId } = this.searchForm;
    this.currentPage = 1;
    this.afterForm = {
      ...this.afterForm,
      code,
      userOrderId,
      aftersaleType,
      page: 0,
      size: this.pagesize,
      partnerId,
    };
    this.afterList(this.afterForm);
  }
  // 重置
  reset() {
    this.$refs['searchForm']['resetFields']();
    // 清输入框
    Object.assign(this.$data.afterForm, this.$options.data['call'](this).afterForm);
    this.afterList(this.afterForm);
  }
  // 获取列表数据
  afterList(afterForm) {
    this.loading = true;
    afterList(afterForm)
      .then((res) => {
        if (res) {
          this.tableData2 = res.content;
          this.totalElements = res['totalElements'];
          this.loading = false;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        this.$message.error(err);
      });
  }

  onSubmit() {
    console.log('submit!');
  }
  // 去详情
  goToDetails(row) {
    this.$router.push(`afterSale_detail?code=${row.code}`);
  }
  // 发货
  delivery(row) {
    if (row) {
      this.nowCode = row.code;
      this.finalAftersaleType = row.finalAftersaleType;
      this.dialogFormVisible1 = true;
    }
  }
  // 退款详情
  aRefund(row) {
    this.nowCode = row.code;
    this.drawer = true;
  }
  // 关闭抽屉
  handleClose(done) {
    this.$confirm('确认关闭？')
      .then((_) => {
        done();
        this.afterList(this.afterForm);
      })
      .catch((_) => {});
  }
  // 分页
  handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
  }
  async handleCurrentChange(val) {
    try {
      console.log(`当前页: ${val}`);
      this.afterForm.page = val - 1;
      await this.afterList(this.afterForm);
    } catch (error) {}
  }
}
